import axios, { InternalAxiosRequestConfig, AxiosResponse } from "axios";

declare var process: { env: { [key: string]: string | undefined } };

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://ceremind-backend.onrender.com";
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

// Cloudpage unlock uses an HttpOnly, cookie-backed public session.  Credentials
// must accompany subsequent API reads when frontend and API use separate local
// origins (and remain harmless for same-origin production deployments).
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg: InternalAxiosRequestConfig) => {
  const isCollaborator = window.location.pathname.startsWith("/collaborator");
  
  if (isCollaborator) {
    // Keep this key aligned with collaboratorApi. The previous legacy key made
    // embedded collaborator modules silently send no authorization at all.
    const collabToken = localStorage.getItem("collaborator_token");
    if (collabToken) {
      cfg.headers.Authorization = `Bearer ${collabToken}`;
    }
    // The table-plan editor uses its historic owner routes. Map those routes to
    // the collaborator equivalents before applying the common portal prefix.
    if (cfg.url && !cfg.url.startsWith("/collaborator-") && !cfg.url.startsWith("http")) {
      const normalizedUrl = cfg.url.startsWith("/") ? cfg.url : `/${cfg.url}`;
      const routeAliases: Record<string, string> = {
        "/room": "/rooms",
        "/walls": "/rooms/walls",
        "/openings": "/rooms/openings",
      };
      const [path, query = ""] = normalizedUrl.split("?");
      const collaboratorPath = routeAliases[path] || path;
      cfg.url = `/collaborator-portal${collaboratorPath}${query ? `?${query}` : ""}`;
    }
  } else {
    const token = localStorage.getItem("wp_token");
    if (token) {
      cfg.headers.Authorization = `Bearer ${token}`;
    }
  }
  return cfg;
});

api.interceptors.response.use(
  (r: AxiosResponse) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("wp_token");
      localStorage.removeItem("collaborator_token");
    }
    return Promise.reject(err);
  }
);

export default api;
